import React from 'react'
import { Box, Autocomplete, TextField, Typography } from '@mui/material'
import { useGetItemId } from '../../api/stock'

export const ItemFilter = (props) => {
  const { setItemId, department, classification, itemId } = props
  const itemIdRes = useGetItemId({
    department: department,
    classification: classification,
  })

  const itemIdArray = itemIdRes?.data ?? []

  const handleSelectItemId = (event, value) => {
    setItemId(value)
  }
  return (
    <Box mb={3}>
      {itemIdArray && itemIdArray.length ? (
        <Autocomplete
          disablePortal
          id='item-autocomplete'
          options={itemIdArray}
          sx={{ maxWidth: 650 }}
          onChange={handleSelectItemId}
          size='small'
          renderInput={(params) => <TextField {...params} label='Item' />}
          value={itemId}
          isOptionEqualToValue={(option, value) => option.value === value.value}
        />
      ) : (
        <Typography>No available item</Typography>
      )}
    </Box>
  )
}
